module.exports = __webpack_public_path__ + "img/btpn.1efe2abe.png";